import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeAlert } from 'actions/common/alert';
import Header from 'components/common/Header';

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeAlert
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/containers/common/Header/index.js